import { Button, Col, Modal, Row, Switch } from "antd";
import { useTranslation } from "react-i18next";

function IncomeDeductionSetupModal({
    type = "income",
    isModalIncomeDeductOpen = false,
    employmentIncome = [],
    employmentDeduct = [],
    onCancelIncomeDeductType = () => { },
    onIncomeDeductTypeSelected = () => { },
    onSubmitIncomeDeductSelected = () => { }
}) {
    const { i18n, t } = useTranslation()

    return (
        <>
            <Modal title={type === 'income' ? t("employee.label.income") : t("employee.label.deduction")}
                destroyOnClose
                open={isModalIncomeDeductOpen}
                zIndex={1001}
                closable={false}
                // onCancel={() => onCancelIncomeDeductType()}
                maskClosable={false}
                onOk={(values) => {
                    console.log("modal ", values);
                }}
                footer={[
                    <Button onClick={() => onCancelIncomeDeductType()}>{t("common.cancel")}</Button>,
                    <Button
                        htmlType="submit"
                        type="primary"
                        onClick={(e) => onSubmitIncomeDeductSelected(type)}
                        style={{ backgroundColor: "var(--button-color)" }}
                    >
                        {t("common.submit")}
                    </Button>
                ]}
                width="40vw"
            >
                {type === 'income' ? employmentIncome?.map((item, index) => (
                    <Row style={{ marginBottom: "16px" }}>
                        <Col span={21}>
                            <span>
                                {item?.income.code == "I01" ?
                                    i18n.language === "en" ? item?.income.nameEn + ` ( ${item?.incomeType?.incomeNameEn}) ${((item?.deductionWithholdingTax || '') + (item?.deductionWithholdingTax ? "%" : ''))}` : item?.income?.name + ` ( ${item?.incomeType?.incomeName} ${((item?.deductionWithholdingTax || '') + (item?.deductionWithholdingTax ? "%" : ''))} )`
                                    : i18n.language === "en" ? item?.income.nameEn : item?.income?.name
                                }
                            </span>
                        </Col>
                        <Col span={3} style={{ textAlignLast: "end" }}>
                            <Switch
                                value={item?.status === 'Y'}
                                // disabled={item?.income?.code === 'I01'}
                                onClick={(e) => {
                                    onIncomeDeductTypeSelected(item, e)
                                }}
                            />
                        </Col>
                    </Row>
                )) : employmentDeduct?.map((item, index) => (
                    <Row style={{ marginBottom: "16px" }}>
                        <Col span={21}>
                            <span>
                                {i18n.language === 'en' ? item?.deduction?.nameEn : item?.deduction?.name}
                            </span>
                        </Col>
                        <Col span={3} style={{ textAlignLast: "end" }}>
                            <Switch
                                value={item?.status === 'Y'}
                                // disabled={item?.deduction?.code === 'D02'}
                                onClick={(e) => {
                                    onIncomeDeductTypeSelected(item, e)
                                }}
                            />
                        </Col>
                    </Row>))}
            </Modal>
        </>
    )
}
export default IncomeDeductionSetupModal